import axiosInstance from "../../../../setup/axios/SetupAxios";

const API_URL = process.env.REACT_APP_BASE_URL; 

export const getAppactivity_URL = `${API_URL}/api/v1/parent/app-activity`;
export const postAllowBlockApp_URL = `${API_URL}/api/v1/parent/block-unblock-app`;
export const putAllowBlockCategory = `${API_URL}/api/v1/parent/category-status`
export const GET_ACTIVITY_DETAIL_URL = `${API_URL}/api/v1/parent/app-details`;
export const GET_BLOCK_APP_LISTS_URL = `${API_URL}/api/v1/parent/preselected-app`;

export function blockAppLists(payload){
    return axiosInstance({
        url:GET_BLOCK_APP_LISTS_URL,
        method:"GET",
        params: payload
    })
}

export function appActivityList(payload){
    return axiosInstance({
        url:getAppactivity_URL,
        method:"GET",
        params: payload
    })
}

export function allowBlockApp(payload){
    return axiosInstance({
        url:postAllowBlockApp_URL,
        method: "POST",
        data: payload
    })
}

export function allowBlockCategory(payload){
    return axiosInstance({
        url:putAllowBlockCategory,
        method: "PUT",
        data: payload
    })
}

export function activityDetailList(payload){
    return axiosInstance({
        url:GET_ACTIVITY_DETAIL_URL,
        method:"GET",
        params:payload
    })
}